<div class="header__progress">
  <!-- add / remove class active -->
  <div id="steps_bar" class="progress active">
    <span [style]="progress" class="progress__bar"></span>
  </div>
</div>
